import React, { useState, useEffect, useRef } from "react";
import "./PhotoAlbum.css";
import { Box, IconButton } from "@mui/material";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import { Icon } from "@mui/material";

const PhotoViewer = (props) => {
  const [selectedImage, setSelectedImage] = useState();
  const [isHovered, setIsHovered] = useState(false);
  const touchX = useRef(null);
  const difference = useRef(null);

  useEffect(() => {
    setSelectedImage(props.images ? props.images[0] : null);
  }, [props.images]);

  const imageClick = (event) => {
    setSelectedImage(event.target.src);
  };

  const touchStart = (event) => {
    touchX.current = event.touches[0].clientX;
  };

  const toucheMove = (event) => {
    if (touchX.current === null) difference.current = null;
    else difference.current = event.touches[0].clientX - touchX.current;
  };

  function previousImage() {
    let index = props.images.indexOf(selectedImage);
    if (index < 1) index = 1;
    setSelectedImage(props.images[index - 1]);
  }

  function nextImage() {
    let index = props.images.indexOf(selectedImage);
    if (index > props.images.length - 2) index = props.images.length - 2;
    setSelectedImage(props.images[index + 1]);
  }

  const touchEnd = () => {
    touchX.current = null;
    console.log(difference.current);
    if (difference.current === null) touchX.current = null;
    else {
      let minSwipe = 50;
      if (difference.current > minSwipe) {
        previousImage();
      } else if (difference.current < -minSwipe) {
        nextImage();
      }
    }
  };

  const showIndicatorDots = (index) => {
    const isSelected = selectedImage == props.images[index];
    return (
      <span
        key={index}
        style={{
          fontSize: 22,
          marginLeft: 5,
          color: isSelected ? "white" : "rgba(255, 255, 255, 0.7)",
          cursor: "pointer",
        }}
        onClick={() => setSelectedImage(props.images[index])}
      >
        •
      </span>
    );
  };

  return (
    <Box width={"min-content"} display={"grid"} margin={"auto"}>
      <Box
        width={"min-content"}
        margin={"auto"}
        marginBottom={"5px"}
        display={"grid"}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <IconButton
          style={{
            visibility:
              isHovered && selectedImage !== props.images[props.images.length - 1]
                ? "visible"
                : "hidden",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            color: "black",
            height: "min-content",
            width: "min-content",
            marginLeft: "auto",
            marginTop: "auto",
            marginBottom: "auto",
            marginRight: "5px",
            gridRow: 1,
            gridColumn: 1,
          }}
          onClick={nextImage}
        >
          <NavigateNext />
        </IconButton>

        <Box
          display="grid"
          style={props.searchResultView ?
            {
              objectFit: "cover",
              width: props.isBookingPage ? "auto" :
                props.innerBoxWidth + "px",
              minHeight: props.boxHeight - 190,
              maxHeight: props.boxHeight - 190,
              gridRow: 1, gridColumn: 1
            } :
            {
              maxWidth: "98vw",
              maxHeight: "360px",
              gridRow: 1, gridColumn: 1,
              borderRadius: "10px"
            }}
        >


          <img
            src={selectedImage}
            alt={""}
            style={props.searchResultView ?
              {
                objectFit: "cover",
                width: props.isBookingPage ? "auto" :
                  props.innerBoxWidth + "px",
                minHeight: props.boxHeight - 190,
                maxHeight: props.boxHeight - 190,
                gridRow: 1, gridColumn: 1
              } :
              {
                maxWidth: "98vw",
                maxHeight: "360px",
                gridRow: 1, gridColumn: 1,
                borderRadius: "10px"
              }
            }
            onTouchStart={touchStart}
            onTouchMove={toucheMove}
            onTouchEnd={touchEnd}
          />

          {(props.searchResultView && isHovered) && <Box
            display="inline-grid"
            gridRow="1"
            gridColumn="1"
            gridAutoFlow={"column"}
          >
            <Box marginLeft={"auto"} marginRight={"auto"} marginTop={"auto"} marginBottom={0}>
              {props.images.map((_, index) => showIndicatorDots(index))}
            </Box>
          </Box>}

        </Box>

        <IconButton
          style={{
            visibility:
              isHovered && selectedImage !== props.images[0] ? "visible" : "hidden",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            color: "black",
            height: "min-content",
            width: "min-content",
            marginLeft: "5px",
            marginTop: "auto",
            marginBottom: "auto",
            marginRight: "auto",
            gridRow: 1,
            gridColumn: 1,
          }}
          onClick={previousImage}
        >
          <NavigateBefore />
        </IconButton>
      </Box>

      {props.searchResultView ? null : (
        <Box display={"inline-flex"} width={"100%"} maxWidth={"98vw"} margin={"auto"} height={"50px"} overflow={"auto"}>
          {props.images?.map((image) => <img alt={""} border={selectedImage === image ? "1px" : "0px"} key={image} src={image} style={{ boxShadow: selectedImage === image ? "1px" : "0px", maxWidth: "100vw", borderColor: "black", borderRadius: "5px", marginLeft: "1px", marginRight: "1px" }} onClick={imageClick} />)}
        </Box>
      )}
    </Box>
  );

};

export default PhotoViewer;
